import React, { useState } from "react";
import { SlMenu } from "react-icons/sl";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useStateContext } from "../global-context/useGlobalContext";

const PhoneMenu = () => {
  const [menu, setMenu] = useState(false);
  const openMenu = () => {
    setMenu(!menu);
  };
  const { pathname } = useLocation();
  const { language, switchLanguageHandler } = useStateContext();
  return (
    <StyledMenu>
      <div
        onClick={() => switchLanguageHandler()}
        className="language"
      >
        <h2>{language ? "EN" : "FR"}</h2>
      </div>
      <SlMenu
        size={20}
        onClick={() => openMenu()}
      />
      <AnimatePresence>
        {menu && (
          <MobileWrapper onClick={() => setMenu(false)}>
            <MobileMenu
              initial={{ opacity: 0, scale: 0, x: 50, y: -120 }}
              animate={{ opacity: 1, scale: 1, x: 0, y: 0 }}
              transition={{ duration: 0.3, type: "linear" }}
              exit={{ opacity: 0, scale: 0, x: 50, y: -120 }}
            >
              <Link to="/">
                <h2
                  style={{
                    color: pathname === "/" ? "#f9cc0b" : "white",
                  }}
                >
                  Découvrez
                </h2>
              </Link>
              <Link to="/projects">
                <h2
                  style={{
                    color: pathname === "/projects" ? "#f9cc0b" : "white",
                  }}
                >
                  Projets
                </h2>
              </Link>
              <Link to="/services">
                <h2
                  style={{
                    color: pathname === "/services" ? "#f9cc0b" : "white",
                  }}
                >
                  Services
                </h2>
              </Link>
              <Link to="/contact">
                <h2
                  style={{
                    color: pathname === "/contact" ? "#f9cc0b" : "white",
                  }}
                >
                  Contact
                </h2>
              </Link>
            </MobileMenu>
          </MobileWrapper>
        )}
      </AnimatePresence>
    </StyledMenu>
  );
};

export default PhoneMenu;

const StyledMenu = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: end;
  position: relative;
  flex: 1;
  .language {
    padding: 0rem 2rem;
  }
`;
const MobileWrapper = styled.div`
  background: transparent;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 20;
  display: flex;
  justify-content: flex-end;
`;
const MobileMenu = styled(motion.div)`
  background: #0c1d36;
  border: solid 1px #f9cc0b;
  box-shadow: 0px 0px 5px #f9cc0b;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border-radius: 1rem;
  padding: 0vh 5vw;
  padding-top: 1.5vh;
  height: 50vh;
  width: 50vw;
  top: 7.5vh;
  right: 7.5vw;
  h2 {
    margin-bottom: 3vh;
    font-weight: 300;
    border-bottom: 1px solid #f9cc0b;
  }
`;
